module.exports = __webpack_public_path__ + "static/media/foco.716df28d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/foco.svg
// module id = 544
// module chunks = 0